<template>
  <div class="pt-rev-switcher">
    <el-button
      :class="['pt-rev-switcher__button', !rev ? 'full-width main' : 'plain']"
      size="mini"
      type="success"
      @click="changeReverse(false)"
    >
      Прямое
    </el-button>
    <el-button
      :class="['pt-rev-switcher__button', rev ? 'full-width main' : 'plain']"
      size="mini"
      type="success"
      @click="changeReverse(true)"
    >
      Обратное
    </el-button>
  </div>
</template>

<script>
import {
  createRouteHelper,
  setReverseRouteStyling,
  setActiveStopPointsStyling
} from "@/libs/map-draw/helpers";

export default {
  props: ["state", "draw", "map", "rev", "reverse-id"],
  methods: {
    changeReverse(type) {
      if (type === this.rev) return;
      const feature = this.state.simpleSelectMode.getFeature(this.reverseId);

      if (!feature) return;

      this.state.activeObject = feature;
      this.$store.commit("SET_PT_STATE_PROP", {
        name: "activeCardId",
        value: this.reverseId
      });
      this.$store.commit("SET_ACTIVE_ROUTE_PROPS", {
        reverse: feature.properties.rev,
        reverseRouteId: feature.properties.reverse_route_id
      });
      this.draw.changeMode("simple_select", {
        featureIds: [this.reverseId]
      });

      const { reverse_route_id, line_route_items } = feature.properties;
      const spIds = line_route_items
        .filter(item => item.stop_point_id)
        .map(item => item.stop_point_id);

      // route arrows
      createRouteHelper(this.map, feature.getCoordinates(), true);
      // reverse route styling
      setReverseRouteStyling(this.map, reverse_route_id);
      // stop points styling
      setActiveStopPointsStyling(this.map, this.$store, spIds);
    }
  }
};
</script>

<style lang="scss">
.pt-rev-switcher {
  position: absolute;
  z-index: 100;
  display: flex;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);

  &__button {
    margin-left: 0 !important;
    border-radius: 0 !important;
    border-color: #55b77e !important;

    &.plain {
      background-color: #99ddb5 !important;
      color: #4a9d6d !important;
    }

    &.main.el-button--primary:hover,
    &.main.el-button--primary:focus {
      background: #55b77e !important;
    }

    &:first-child {
      border-top-left-radius: var(--border-radius) !important;
      border-bottom-left-radius: var(--border-radius) !important;
    }
    &:last-child {
      border-top-right-radius: var(--border-radius) !important;
      border-bottom-right-radius: var(--border-radius) !important;
    }

    span {
      margin-left: 0 !important;
    }

    &.full-width {
      flex: 1;
      background-color: #55b77e !important;
      color: var(--white_white);

      span {
        margin-left: 5px;
      }
    }
  }
}
</style>
